import { TextField, Typography, Box, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import EditInfo, { EDIT_INFO_TYPE } from '../../components/EditInfo/EditInfo';
import useRequestCommentCommon from '../../hooks/useRequestCommentCommon';

const useStyles = makeStyles(() => ({
    noBorder: {
        '& fieldset': { border: 'none !important', },
    },
    readOnlyPadding: {
        padding: '0px !important',
        '& .MuiOutlinedInput-inputMultiline': { padding: '0px !important', },
    },
    editableNoPadding: {
        padding: '0px !important',
        '& .MuiOutlinedInput-inputMultiline': { padding: '8px !important', },
    },
    commentInputLabel: {
        fontSize: '12px !important',
        fontWeight: '600',
        '& *': { fontSize: '10px !important', fontWeight: '600', fontFamily: 'Montserrat !important', }
    }
}));

export const InputBox = ({ label, readOnly = false, data = undefined, updatedDate, created_date }) => {
    const classes = useStyles();
    const [value, setValue] = useState('');

    const handleOnChange = (e) => {
        setValue(e.target.value);
    };

    useEffect(() => {
        if (data !== undefined) {
            setValue(data);
        }
    }, [data]);

    return (
        <Box>
            <Box style={{ display: "flex", justifyContent: "space-between", alignContent: "center", padding: "4px 0", alignItems: "center", gap: "8px" }}>
                <Typography className={classes.commentInputLabel}>
                    {label}
                </Typography>
                <Box>
                    <EditInfo type={EDIT_INFO_TYPE.REQUEST} updatedDate={updatedDate} created_date={created_date} />
                </Box>
            </Box>
            <TextField
                multiline
                minRows={4}
                style={{ width: '100%' }}
                variant="outlined"
                InputProps={{
                    readOnly: readOnly,
                    classes: {
                        root: `${readOnly ? `${classes.readOnlyPadding} ${classes.noBorder}` : classes.editableNoPadding}`
                    },
                }}
                inputProps={{ style: { fontSize: '14px', } }}
                InputLabelProps={{ shrink: true, }}
                value={value ?? ''}
                onChange={handleOnChange}
            />
        </Box>
    );
};
